class RcsSectionUtils {
  static getRcsSubSection() {
    let subsection = '';

    let domElement = document.querySelector('[data-rcs-subsection]');
    if (domElement !== null) {
      subsection = domElement.getAttribute('data-rcs-subsection');
    }

    return subsection;
  }

  static getRcsSection() {
    let section = '';

    let domElement = document.querySelector('[data-rcs-section]');
    if (domElement !== null) {
      section = domElement.getAttribute('data-rcs-section');
    }

    return section;
  }

  static getRcsTipologia() {
    let tipologia = '';

    let domElement = document.querySelector('[data-rcs-tipologia]');
    if (domElement !== null) {
      tipologia = domElement.getAttribute('data-rcs-tipologia');
    }

    return tipologia;
  }

  static getNameLocal() {
    let nameLocal = '';

    let domElement = document.querySelector('[data-rcs-namelocal]');
    if (domElement !== null) {
      nameLocal = domElement.getAttribute('data-rcs-namelocal');
    }

    return nameLocal;
  }

  static checkIfIsLocal(section) {
    let isLocal = false;
    let localSections = [
      'milano',
      'roma',
      'bergamo',
      'brescia',
      'firenze',
      'napoli',
      'bari',
      'salerno',
      'caserta',
      'palermo',
      'lecce',
      'foggia',
      'veneto',
      'bologna',
      'torino'
    ];

    if (localSections.indexOf(section) > -1) {
      isLocal = true;
    }

    return isLocal;
  }

  static checkIfIsSudLocal(section) {
    let isSubLocal = false;
    let sudLocalSections = [
      'napoli',
      'bari',
      'salerno',
      'caserta',
      'palermo',
      'lecce',
      'foggia'
    ];

    if (sudLocalSections.indexOf(section) > -1) {
      isSubLocal = true;
    }

    return isSubLocal;
  }
}

module.exports = RcsSectionUtils;



// WEBPACK FOOTER //
// ./src/rcs_cor_continous-related-link/utils/RcsSectionUtils.js